// styles
import { Button, Container, ContainerForm, ContentForm, Form, Input, MessageError} from "./styles";

// components
import { Paragraph } from "../shared/text/paragraph";
import { Title } from "../shared/text/titles";

//libs
import { useForm, SubmitHandler } from "react-hook-form";
import { toast } from "react-toastify";
import { db } from "../../firebase";
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc } from "firebase/firestore";

interface DatasType{
  name: string;
  email: string;
  telegram: string;
  description_project: string;
}

export function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<DatasType>();
  
  const usersCollection = collection(db, "users")

  const onSubmit: SubmitHandler<DatasType> = async (data, e) => {
    console.log(data);
    
    await addDoc(
      usersCollection,
      {
        name: data.name,
        email: data.email,
        telegram: data.telegram,
        project_description: data.description_project,
      },);

      toast.success("Sent successfully! 🎊", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      e?.target.reset();
  };

  return (
    <>
      <Container>
        <Paragraph>Let's talk</Paragraph>
        <Title>Contact us</Title>

        <Paragraph>Let's work together</Paragraph>

        <ContainerForm>
          <ContentForm onSubmit={handleSubmit(onSubmit)}>
            <Form>
              <Paragraph>Name</Paragraph>
              <Input {...register("name", { required: true })} />
              {errors.name && (
                <MessageError>This field is required</MessageError>
              )}
            </Form>

            <Form>
              <Paragraph>Email</Paragraph>
              <Input {...register("email", { required: true })} />
              {errors.email && (
                <MessageError>This field is required</MessageError>
              )}
            </Form>

            <Form>
              <Paragraph>Telegram</Paragraph>
              <Input {...register("telegram")} />
            </Form>

            <Form>
              <Paragraph>Description project</Paragraph>
              <Input {...register("description_project", { required: true })} />
              {errors.description_project && (
                <MessageError>This field is required</MessageError>
              )}
            </Form>
            <div style={{ display: "flex", justifyContent: "right" }}>
              <Button type="submit">Submit</Button>
            </div>
          </ContentForm>
        </ContainerForm>
      </Container>
    </>
  );
}